
import React from 'react';
import { useNavigate } from 'react-router-dom'
import { LINX_REDIRECT_URI } from '../../utils/constants'
import SdmClient,{ PlatformType } from 'sdm-js-sdk';
import axios from "axios";
import VConsole from 'vconsole';
import { LINX_AUTH_INFO } from '../../utils/constants'
import { getPlatformInfo } from '../../utils/getPlatformInfo'
import { sdmuser } from '../../utils/api'
import { divide } from 'lodash';
import { redirectUri, clientId } from './key'


function timeoutReject(reject: any, msg: string) {
    setTimeout(() => {
        reject(msg);
    }, 10000);
}


class Empower extends React.Component {

    dispatch?: any;
    clientType?: any;
    SdmClientInstance: any;
    // SdmClient: any;

    vConsole = new VConsole();
    constructor({ dispatch, postmate }: { dispatch?: any; postmate?: any }) {
        super(dispatch);
        this.dispatch = dispatch;
        const isAndroid = getPlatformInfo()?.isAndroid;
        const isSdm = getPlatformInfo()?.isSdm;
        const type = isSdm ? (isAndroid ? PlatformType.Android : PlatformType.iOS) : PlatformType.Web;
        // const type = PlatformType.Web
        this.clientType = type;
        // this.SdmClientInstance = new SdmClientSDk({
        //     type,
        //     postmate
        // });

        this.SdmClientInstance = new SdmClient({
            type,
            postmate
        });

    }

    // navigate = useNavigate()


    state = {
        loginType: 8,   //登录方式 固定值为8 去中心app登录方式
        // code: localStorage.getItem('code'), //authorizeCode 通过js sdk 获取
        code: '', //authorizeCode 通过js sdk 获取
        redirectUri: redirectUri,
        clientId: clientId, //申请的clientId
        // walletAddress: localStorage.getItem('walletAddress'), //js sdk 获取用户信息中
        walletAddress: '',
        // userId: localStorage.getItem('userId'), //js sdk 获取用户信息中
        userId: '', //js sdk 获取用户信息中
        // userName: localStorage.getItem('userName'),//js sdk 获取用户信息中
        userName: '',//js sdk 获取用户信息中
        userImgUrl: null, //js sdk 获取用户信息中
        show2: false,
        country: ['Worldwide', 'China', 'United States', 'France', 'Britain', 'Germany', 'India']
    }


    


    componentDidMount() {

        let a = '0'
        localStorage.setItem('countryshow', a)
        this.setState({
            code: localStorage.getItem('code'),
            walletAddress: localStorage.getItem('walletAddress'),
            userId: localStorage.getItem('userId'),
            userName: localStorage.getItem('userName'),
        })
        
        // 获取好友信息
        // this.getMyContacts()
        this.getMyFriends()
        
        console.log('5月17日13：00打包')
        console.log(localStorage.getItem('code') == '' || localStorage.getItem('code') == null)
        console.log(this.state.code, 'code')
        console.log(localStorage.getItem('code'))

        if (localStorage.getItem('code') == '' || localStorage.getItem('code') == null) {
            console.log('重新登录')
            this.fetchAuthorizeCode()
        } else {
            if (localStorage.getItem('userToken') == '' || localStorage.getItem('userToken') == null) {
                console.log('重新登录')
                this.fetchAuthorizeCode()
            } else {
                console.log('跳过登录')
                console.log('开始跳转')
                window.history.replaceState("", "", '/home');
                window.history.go(0);
            }

        }
    }







    fetchAuthorizeCode() {
        
        console.log('sdn-fetchAuthorizeCode');
        console.log('SdmClient2');
        // SdmClient.fetchAuthorizeCode(
        this.SdmClientInstance.fetchAuthorizeCode(
            'code',
            LINX_AUTH_INFO.clientId,
            LINX_AUTH_INFO.redirectUri,
            (result: any) => {
                console.log('sdn-callback-fetchAuthorizeCode', result);
                
                if (result) {
                    console.log('获取code')
                    const code = result?.authorization_code ? result?.authorization_code : result;
                    // eventgocode
                    console.log('存本地code')

                    localStorage.setItem('code', result?.authorization_code ? result?.authorization_code : result)
                    this.setState({
                        code: code
                    })

                    console.log('获取个人信息')
                    this.getMyProfile()

                } else {
                    console.log('获取失败')
                }
            }
        );
    }


    // getUserContacts(walletAddress:any) {
    //     this.SdmClientInstance.getUserContacts(
    //         walletAddress,
    //         (result: any) => {
    //             console.log('sdn-callback-getUserContacts', result);
    //             if (result) {

    //                 console.log(result)

    //             } else {
    //                 console.log('获取失败')
    //             }
    //         }
    //     );
    // }

    getUserContacts(walletAddress: any) {
        this.SdmClientInstance.getUserContacts(
            // this.SdmClient.getUserContacts(
            walletAddress,
            (result: any) => {
                console.log('sdn-callback-getUserContacts', result);
                if (result) {

                    console.log(result)

                } else {
                    console.log('获取失败')
                }
            }
        );
    }


    // getMyContacts() {
    //     console.log('开始获取好友信息')
    //     const callback = (contacts: any) => {
    //         console.log('获取好友信息')
    //         console.log('sdn-callback-getMyContacts', contacts);
    //         localStorage.setItem('getMyContacts', JSON.stringify(contacts.contacts))

    //     }
    //     this.SdmClientInstance.getMyContacts(callback)
    //     // this.SdmClient.getMyContacts(callback)
    // };

    getMyFriends() {
        console.log('开始获取好友信息','getMyFriends')
        const callback = (contacts: any) => {
            console.log('获取好友信息','getMyFriends')
            console.log('sdn-callback-getMyFriends', contacts);
            console.log(contacts.friends);
            localStorage.setItem('getMyContacts', JSON.stringify(contacts.friends))

        }
        this.SdmClientInstance.getMyFriends(callback)
        // this.SdmClient.getMyContacts(callback)
    };


    


    getUserProfile(userId: string) {
        console.log('sdn-getUserProfile', userId);
        const getUserProfileCallback = (userProfile: any) => {
            console.log('getUserProfileCallback', userId, userProfile);
        };
        this.SdmClientInstance.getUserProfile(userId, getUserProfileCallback);
        // this.SdmClient.getUserProfile(userId, getUserProfileCallback);
    }


    getMyProfile() {
        return new Promise((resolve, reject) => {
            const callback = (userProfile: any) => {

                console.log('sdn-callback-getMyProfile', userProfile);
                console.log(1111111);
                if (userProfile?.userId) {

                    localStorage.setItem('walletAddress', userProfile.walletAddress)
                    localStorage.setItem('userId', userProfile.userId)
                    localStorage.setItem('userName', userProfile.name)
                    localStorage.setItem('avatar', userProfile.avatar)


                    // this.getUserContacts(userProfile.walletAddress)

                    this.setState({
                        walletAddress: userProfile.walletAddress, //js sdk 获取用户信息中
                        userId: userProfile.userId,//js sdk 获取用户信息中
                        userName: userProfile.userName,//js sdk 获取用户信息中
                    })

                    console.log('Get Friend Information')
                    // this.getMyContacts()

                    console.log('User information is saved')
                    this.getuserinformation()
                    // this.navigate('/home')
                    // this.NewUsers()QSSSSSSSSSSSSSSSSSSSSSS



                    return resolve(userProfile);
                } else {
                    return reject('User Info error, please try again later');
                }
            };
            this.SdmClientInstance.getMyProfile(callback);
            // this.SdmClient.getMyProfile(callback);
            timeoutReject(reject, 'sdn-timout-getMyProfile');
        }).catch((e) => {
            console.log(e, 'Access failure')
        });
    }

    getuserinformation() {
        let url = LINX_REDIRECT_URI + '/user/checkUserAndGenToken'
        const formData = {
            loginType: this.state.loginType,
            code: this.state.code,
            redirectUri: this.state.redirectUri,
            clientId: this.state.clientId,
            walletAddress: this.state.walletAddress,
            userId: this.state.userId,
            userName: this.state.userName,
        }
        axios({
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'post',
            url: url,
            data: formData,
        }).then(res => {
            console.log(res, 'get userToken')
            if (res.data.success) {
                console.log('get userToken success')
                localStorage.setItem('userToken', res.data.result.userToken)
                localStorage.setItem('userinformation', JSON.stringify(res.data.result))

                this.setState({
                    linxUserId: res.data.result.linxUserId,
                    linxImgUrl: res.data.result.linxImgUrl,
                    linxUserName: res.data.result.linxUserName,
                    walletAddress: res.data.result.walletAddressMetamask,
                })
                this.NewUsers(res.data.result.userId, res.data.result.imgUrl, res.data.result.userName, res.data.result.linxUserId, res.data.result.walletAddressMetamask)
            } else {
                console.log('code Lose effectiveness')
                console.log('Acquisition failure')
                this.fetchAuthorizeCode()
            }

        })

    }

    NewUsers(sdmUserId: number | null, sdmUserName: string | null, imgUrl: string | null, linxUserId: string | null, walletDdressEtamask: string | null) {

        let name = sdmUserName ? sdmUserName : localStorage.getItem('userName')
        let url = imgUrl ? imgUrl : localStorage.getItem('avatar')

        console.log(sdmUserId, name, url, linxUserId, walletDdressEtamask)
        sdmuser({
            sdmUserId: sdmUserId,
            sdmUserName: name,
            imgUrl: url,
            linxUserId: linxUserId,
            walletDdressEtamask: walletDdressEtamask
        }).then((res) => {
            console.log('Start jump')
            window.history.replaceState("", "", '/home');
            window.history.go(0);
        });
    }

    NewUsers2() {

        sdmuser({
            sdmUserId: '101705466686170864',
            sdmUserName: 'xiao44868278548',
            imgUrl: "https://storage.googleapis.com/linx-sdn/image/1705466601975-0xf30faa700b335bbe9b8d8d2e44d51228bb67ea88",
            linxUserId: "@sdn_f30faa700b335bbe9b8d8d2e44d51228bb67ea88:f30faa700b335bbe9b8d8d2e44d51228bb67ea88",
            walletDdressEtamask: "0xf30faa700b335bbe9b8d8d2e44d51228bb67ea88"
        }).then((res) => {

        });
    }

    // setcountry(item:string){
    //     localStorage.setItem('country', item)
    //     window.history.replaceState("", "", '/home');
    //     window.history.go(0);
    // }

    render() {
        return <div>
            {/* 测试使用，线上删除 */}
            {/* <div style={{ color: '#fff', textAlign: 'center', padding: '20px' }}>
                <div style={{ padding: '20px', fontSize: '24px', fontWeight: '700' }}>
                    Please select your country
                </div>
                <div style={{ fontSize: '14px', marginTop: '10px' }}>{
                    this.state.country.map((item, index) => 
                    <div key={index} onClick={()=> this.setcountry(item)}   style={{ padding: '15px', borderBottom: '1px solid #464646' }}>{item}</div>)
                }</div>
            </div> */}
        </div>

    }
}


export default Empower;